import { useEffect, useState } from 'react'
import SliderImages from '../../component/CustomSlider/SliderImages'
import './style.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTaxi } from '@fortawesome/free-solid-svg-icons'
import DateRangeSelector from '../Flights/Dropdown/DateSelector'
import moment from 'moment'
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { useDispatch } from 'react-redux'
import {
  setLoadingFalse,
  setLoadingTrue
} from '../../Config/Actions/loadingActions'
import axios from 'axios'
import dayjs from 'dayjs'
import SearchDropdown from '../Flights/Dropdown/SearchDropdown'
import { City, Country, State } from 'country-state-city'
import EndDateSelector from '../Flights/Dropdown/endDateSelector'

const Cabs = () => {
  const [sliderImages, setSliderImages] = useState([])
  const [flightsForm, setFlightsForm] = useState([])
  const [dateRangeOpen, setDateRangeOpen] = useState(false)
  const [pickupTime, setPickupTime] = useState(null)
  const [selectedFare, setSelectedFare] = useState('4 Seater')
  const [success, setSuccess] = useState(false)
  const [endOpen, setDateEndOpen] = useState(false)
  const [openPicker, setOpenPicker] = useState(false)

  useEffect(() => {
    fetch('/PackageJson/Cabs/CabsImages.json')
      .then(response => response.json())
      .then(data => {
        setSliderImages(data)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [])
  useEffect(() => {
    fetch('/PackageJson/Cabs/CabsForm.json')
      .then(response => response.json())
      .then(data => {
        setFlightsForm(data)
      })
      .catch(error => console.error('Error loading JSON:', error))
  }, [])

  const [tripType, setTripType] = useState('One Way')

  const handleChangeTripType = event => {
    setTripType(event.target.value)
  }

  const [formData, setFormData] = useState({
    full_name: '',
    contact: '',
    email: '',
    product_type: 'hotels',
    departureDate: '',
    returnDate: '',
    PickupAddress: '',
    pickupTime: null,
    From: '',
    To: '',
    searchTerm: ''
  })
  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }))
  }
  const dispatch = useDispatch()
  const handleSubmit = async e => {
    e.preventDefault()
    dispatch(setLoadingTrue())
    const FormData = {
      to: formData.email,
      subject: 'Cabs',
      fullName: formData.full_name,
      Email: formData.email,
      Contact: formData.contact,
      startDate: moment(formData.departureDate).format('DD MMM YYYY'),
      EndDate: moment(formData.returnDate).format('DD MMM YYYY'),
      TripType: tripType,
      Vehicle: selectedFare,
      PickupAddress: formData.PickupAddress,
      PickupTime: dayjs(formData.pickupTime).format('hh:mm A'),
      From: formData.From,
      To: formData.To
    }

    try {
      const response = await axios.post(
        'https://arrshiyanatravels.com/api/send_email.php',
        FormData
      )
      dispatch(setLoadingFalse())
      setSuccess(true)
      setTimeout(() => setSuccess(false), 3000)
      setFormData(prevState => ({
        ...prevState,
        full_name: '',
        contact: '',
        email: '',
        product_type: 'hotels',
        departureDate: '',
        returnDate: '',
        PickupAddress: '',
        pickupTime: null,
        From: '',
        To: ''
      }))
    } catch (error) {
      console.error('Error submitting form:', error)
    }
  }
  const allLocations = [
    ...City.getAllCities().map(city => ({
      name: city.name,
      type: 'City',
      countryCode: city.countryCode
    })),
    ...State.getAllStates().map(state => ({
      name: state.name,
      type: 'State',
      countryCode: state.countryCode
    })),
    ...Country.getAllCountries().map(country => ({
      name: country.name,
      type: 'Country',
      countryCode: country.isoCode
    }))
  ]

  const handleLocationToSelect = selectedLocation => {
    setFormData(prevState => ({
      ...prevState,
      To: selectedLocation
    }))
  }
  const handleLocationSelect = selectedLocation => {
    setFormData(prevState => ({
      ...prevState,
      From: selectedLocation
    }))
  }
  const handleOnchangeDate = item => {
    setFormData(prevState => ({
      ...prevState,
      departureDate: item.selection.startDate
    }))
  }
  const handleOnchangeEndOpen = item => {
    setFormData(prevState => ({
      ...prevState,
      returnDate: item.selection.startDate
    }))
  }

  return (
    <div>
      <div
        style={{
          height: '',
          backgroundImage: `url(${flightsForm[0]?.displayBackground})`,
          backgroundPosition: 'center',
          backgroundSize: 'Cover',
          backgroundRepeat: 'no-repeat',
          padding: '80px 0px'
        }}
        className='product-container Cabs Cabs-One'
      >
        <div className='container'>
          <div className='product-area hotels'>
            <form onSubmit={handleSubmit}>
              <div className='radio-group'>
                <label
                  className={`radio-label ${
                    tripType === 'One Way' ? 'selected' : ''
                  }`}
                >
                  <input
                    type='radio'
                    name='tripType'
                    value='One Way'
                    checked={tripType === 'One Way'}
                    onChange={handleChangeTripType}
                    className='radio-input'
                  />
                  <span className='custom-radio'></span>
                  One Way
                </label>

                <label
                  className={`radio-label ${
                    tripType === 'Round Trip' ? 'selected' : ''
                  }`}
                >
                  <input
                    type='radio'
                    name='tripType'
                    value='Round Trip'
                    checked={tripType === 'Round Trip'}
                    onChange={handleChangeTripType}
                    className='radio-input'
                  />
                  <span className='custom-radio'></span>
                  Round Trip
                </label>
              </div>
              <div className='row'>
                <div
                  className={` ${
                    tripType === 'Outstation'
                      ? 'col-lg-5 col-md-12 col-sm-12'
                      : 'col-lg-6 col-md-12 col-sm-12'
                  } `}
                >
                  <div className='form-group airport-list'>
                    <div className='search-input-box '>
                      <label className='form-label'>From </label>
                      {/* <input
                        className='autocomplete-airport inp-text '
                        id='search-user'
                        type='text'
                        name='From'
                        value={formData.From}
                        onChange={handleChange}
                        autoComplete='off'
                        required
                      /> */}

                      <SearchDropdown
                        setFormData={setFormData}
                        formData={formData}
                        value={formData.From}
                        data={allLocations}
                        placeholder=''
                        onSelect={handleLocationSelect}
                      />
                    </div>
                    <div className='flight-swipe'>
                      <img
                        src='PackageJson/Flights/Images/swap.png'
                        alt='swap.png'
                        width='50px'
                      />
                    </div>
                    <div
                      className='search-input-box '
                      style={{ float: 'right' }}
                    >
                      <label className='form-label'>To </label>
                      {/* <input
                        className='autocomplete-airport inp-text '
                        id='search-user'
                        type='text'
                        name='To'
                        value={formData.To}
                        onChange={handleChange}
                        autoComplete='off'
                        required
                      /> */}
                      <SearchDropdown
                        formData={formData}
                        value={formData.To}
                        data={allLocations}
                        placeholder=''
                        onSelect={handleLocationToSelect}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className={` ${
                    tripType === 'Outstation'
                      ? 'col-lg-7 col-md-12 col-sm-12 round-cab'
                      : 'col-lg-6 col-md-12 col-sm-12'
                  } `}
                >
                  <div className='form-group'>
                    <div className='subContent'>
                      <div
                        className={`${
                          tripType === 'Round Trip'
                            ? 'search-input-box departure'
                            : 'search-input-box departure RoundDate '
                        }`}
                      >
                        <div
                          onClick={() => setDateRangeOpen(true)}
                          style={{
                            position: 'absolute',
                            left: '0px',
                            right: '0px',
                            width: '100%',
                            height: '100%'
                          }}
                        ></div>
                        <label className='form-label'>DEPARTURE</label>
                        <div className='form-holder'>
                          <input
                            onClick={() => setDateRangeOpen(true)}
                            className='autocomplete-airport inp-text'
                            type='text'
                            name='departure_date'
                            value={
                              formData.departureDate
                                ? moment(formData.departureDate).format(
                                    'DD MMM YYYY'
                                  )
                                : formData.departureDate
                            }
                            placeholder=''
                            required
                          />
                          <p>
                            <span>
                              {formData.departureDate
                                ? moment(formData.departureDate).format('dddd')
                                : ''}
                            </span>
                          </p>
                          <DateRangeSelector
                            dateRangeOpen={dateRangeOpen}
                            setDateRangeOpen={setDateRangeOpen}
                            handleOnchangeDate={handleOnchangeDate}
                          />
                        </div>
                      </div>
                      {tripType === 'Round Trip' && (
                        <div className='search-input-box departure'>
                          <div
                            onClick={() => setDateEndOpen(true)}
                            style={{
                              position: 'absolute',
                              left: '0px',
                              right: '0px',
                              width: '100%',
                              height: '100%'
                            }}
                          ></div>
                          <label className='form-label'>RETURN</label>
                          <div className='form-holder'>
                            <input
                              onClick={() => setDateEndOpen(true)}
                              className='autocomplete-airport inp-text'
                              type='text'
                              name='departure_date'
                              value={
                                formData.returnDate
                                  ? moment(formData.returnDate).format(
                                      'DD MMM YYYY'
                                    )
                                  : formData.returnDate
                              }
                              placeholder=''
                              required
                            />
                            <p>
                              <span>
                                {formData.returnDate
                                  ? moment(formData.returnDate).format('dddd')
                                  : ''}
                              </span>
                            </p>

                            <EndDateSelector
                              formData={formData}
                              dateRangeOpen={endOpen}
                              setDateRangeOpen={setDateEndOpen}
                              handleOnchangeDate={handleOnchangeEndOpen}
                            />
                          </div>
                        </div>
                      )}
                      <div
                        className='search-input-box  traveler '
                        style={{ position: 'relative' }}
                      >
                        <div
                          onClick={() => setOpenPicker(true)}
                          style={{
                            position: 'absolute',
                            left: '0px',
                            right: '0px',
                            width: '100%',
                            height: '100%',
                            zIndex: '99'
                          }}
                        ></div>
                        <label className='form-label'>Pickup-Time</label>
                        <div className='form-holder Pickup-time'>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <TimePicker
                              label='Pickup Time'
                              value={formData.pickupTime}
                              open={openPicker}
                              // onOpen={() => setOpenPicker(false)}
                              onClose={() => setOpenPicker(false)}
                              onAccept={() => setOpenPicker(false)}
                              onChange={newTime => {
                                setFormData(prevState => ({
                                  ...prevState,
                                  pickupTime: newTime
                                }))
                              }}
                              slotProps={{
                                textField: {
                                  sx: {
                                    '& .MuiOutlinedInput-notchedOutline': {
                                      border: 'none'
                                    }
                                  }
                                }
                              }}
                            />
                          </LocalizationProvider>
                        </div>
                      </div>
                      {tripType === 'Outstation' && (
                        <div
                          className='search-input-box  traveler'
                          onClick={() => setOpenPicker(true)}
                        >
                          <label className='form-label'>DROP-Time</label>
                          <div className='form-holder'>
                            <div className='form-holder Pickup-time'>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <TimePicker
                                  label='Pickup Time'
                                  value={formData.pickupTime}
                                  onChange={newTime =>
                                    setFormData(prevState => ({
                                      ...prevState,
                                      pickupTime: newTime
                                    }))
                                  }
                                  open={openPicker}
                                  onAccept={() => setOpenPicker(false)}
                                  onOpen={() => setOpenPicker(true)}
                                  onClose={() => setOpenPicker(false)}
                                  slotProps={{
                                    textField: {
                                      sx: {
                                        '& .MuiOutlinedInput-notchedOutline': {
                                          border: 'none'
                                        }
                                      }
                                    }
                                  }}
                                />
                              </LocalizationProvider>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-lg-7 col-md-12 col-12 enquiry-form'>
                  <div className='row'>
                    <div className='col-md-4  m-b-10'>
                      <div className='form-group'>
                        <input
                          type='text'
                          className='form-control'
                          name='full_name'
                          placeholder='Full Name'
                          value={formData.full_name}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className='col-md-4  m-b-10'>
                      <div className='form-group'>
                        <input
                          type='text'
                          className='form-control'
                          name='contact'
                          placeholder='Mobile Number'
                          pattern='^\d*$'
                          value={formData.contact}
                          onChange={handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className='col-md-4'>
                      <div className='form-group'>
                        <input
                          type='text'
                          className='form-control'
                          name='email'
                          placeholder='Email ID'
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                        <input
                          type='hidden'
                          name='product_type'
                          value='hotels'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='form-group mt-3'>
                    <input
                      type='Address'
                      className='form-control'
                      name='PickupAddress'
                      placeholder='Pickup Address'
                      value={formData.PickupAddress}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-6 col-md-12 col-12'>
                    <div className='quota-box'>
                      <div className='q-label'>
                        <p>Vehicle:</p>
                      </div>
                      <div className='radio-group'>
                        <label
                          className={`radio-label ${
                            selectedFare === '4 Seater' ? 'selected' : ''
                          }`}
                        >
                          <input
                            type='radio'
                            name='Regular'
                            value='4 Seater'
                            checked={selectedFare === '4 Seater'}
                            onChange={e => setSelectedFare(e.target.value)}
                            className='radio-input'
                          />
                          <span className='custom-radio'></span>4 Seater
                        </label>

                        <label
                          className={`radio-label ${
                            selectedFare === '5-7 Seater' ? 'selected' : ''
                          }`}
                        >
                          <input
                            type='radio'
                            name='Student'
                            value='5-7 Seater'
                            checked={selectedFare === '5-7 Seater'}
                            onChange={e => setSelectedFare(e.target.value)}
                            className='radio-input'
                          />
                          <span className='custom-radio'></span>5-7 Seater
                        </label>
                        <label
                          className={`radio-label ${
                            selectedFare === '7+ Seater' ? 'selected' : ''
                          }`}
                        >
                          <input
                            type='radio'
                            name='Student'
                            value='7+ Seater'
                            checked={selectedFare === '7+ Seater'}
                            onChange={e => setSelectedFare(e.target.value)}
                            className='radio-input'
                          />
                          <span className='custom-radio'></span>7+ Seater
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-6 col-md-12 col-12'>
                    <div className='recent-box'>
                      <div id='date'></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='button-center'>
                <button type='submit' className='btn search-btn'>
                  <FontAwesomeIcon icon={faTaxi} className='planeIcon' />
                  <span className='button-text'>ENQUIRE NOW</span>
                </button>
              </div>
            </form>
            {success && (
              <div className='success-popup'>Thank you for your enquiry!</div>
            )}
          </div>
        </div>
      </div>
      {/* <h2 className='text-white'>{sliderImages[0]?.title}</h2> */}
      <SliderImages data={sliderImages[0]?.displayImages || []} />
    </div>
  )
}
export default Cabs
